const page404 = {
    tagLine: 'GAINS NOT FOUND',
    button: 'GO BACK TO THE SITE',
    amigoText: "You're on the wrong page there buddy, please click on the button to return to the site or else I will become big and strong and make you!"
}
export default page404